import React from 'react';
import { SimpleForm } from 'react-admin';
import { withStyles } from '@material-ui/core';

const styles = {
  form: {
    '& > div:first-child':{
      padding: '24px 24px 0',
    }
  },

};

const StyledSimpleForm = ({classes, ...rest}) => <SimpleForm className={classes.form} {...rest}/>

export default withStyles(styles)(StyledSimpleForm)
